import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import Model3D from '@/components/Model3D';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';

interface ItemProps {
    tab: string;
    glb: string;
    pc?: string;
    glb2?: string;
}

// interface ModelCache {
//     scene: THREE.Group;
//     animations: THREE.AnimationClip[];
// }

export default function Comp() {
    const { t } = useLang('theProduct.SectionN');
    const [activeTab, setActiveTab] = useState(0);
    const [activeIcon, setActiveIcon] = useState('1');
    const { locale = 'us' } = getLocal();
    const handleGtm = (idx: number) => {
         gtm.push({
            event: "uaEvent",
            event_name : "product_detail_page",
            list_name: t('title'),
            button_name: idx === 0 ? 'Rotate Product Icon' : 'Product Size Icon'
        });
    }
    const items: ItemProps[] = [
        {
            tab: t('tab1'),
            // glb: 'https://websiteoss.ecoflow.com/upload/image/1743506143764/glacier2_35L.gltf',
            glb: 'https://websiteoss.ecoflow.com/upload/image/1744073724341/35L.glb',
            pc: locale === 'us' ? 'https://websiteoss.ecoflow.com/upload/image/1744770218433/US-35L.png' : 'https://websiteoss.ecoflow.com/upload/image/1744770296536/35L.png',
        },
        {
            tab: t('tab2'),
            // glb: 'https://websiteoss.ecoflow.com/upload/image/1743506143941/glacier2_45L.gltf',
            glb: 'https://websiteoss.ecoflow.com/upload/image/1744073724695/45L.glb',
            pc: locale === 'us' ? 'https://websiteoss.ecoflow.com/upload/image/1744770218657/US-45L.png' : 'https://websiteoss.ecoflow.com/upload/image/1744770296718/%E5%85%B6%E4%BB%96-45L.png',
        },
        {
            tab: t('tab3'),
            // glb: 'https://websiteoss.ecoflow.com/upload/image/1743506144112/glacier2_55L.gltf',
            glb: 'https://websiteoss.ecoflow.com/upload/image/1744073724522/55L.glb',
            pc: locale === 'us' ? 'https://websiteoss.ecoflow.com/upload/image/1744770218826/US-55L.png' : 'https://websiteoss.ecoflow.com/upload/image/1744770296958/%E5%85%B6%E4%BB%96-55L.png',
        },
    ];

    const icons: {key: string, icon: JSX.Element}[] = [
        {
            key: '1',
            icon: <svg width="1em" height="1em" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.74164 20.6554L10.6281 20.4196C12.8637 20.1401 15.1145 20 17.3675 20C25.191 20 33.0145 20 40.8379 20C47.4703 20 54.1026 20 60.735 20C63.1331 20 65.5298 20.1195 67.916 20.3582L71.2147 20.688C72.0727 20.7738 72.726 21.4958 72.726 22.358V60.2797C72.726 62.1335 71.2232 63.6364 69.3694 63.6364H10.6281C8.7743 63.6364 7.27148 62.1335 7.27148 60.2797V22.3208C7.27148 21.4743 7.90176 20.7604 8.74164 20.6554Z" stroke="currentColor" strokeWidth="3.5"/>
            <path d="M7.27148 29H72.0027" stroke="currentColor" strokeWidth="3.5" strokeLinecap="square"/>
            <path d="M13 20L13.8438 24H34.0938L35.7812 25H45.0625L47.5938 24H66.1562L67 20" stroke="currentColor" strokeWidth="3"/>
            <path d="M69.1538 36H62.8462C61.8266 36 61 36.8266 61 37.8462V46.1538C61 47.1734 61.8266 48 62.8462 48H69.1538C70.1734 48 71 47.1734 71 46.1538V37.8462C71 36.8266 70.1734 36 69.1538 36Z" stroke="currentColor" strokeWidth="3" strokeLinecap="square"/>
            <path d="M66 40V43.6364" stroke="currentColor" strokeWidth="2.08" strokeLinecap="square"/>
            </svg>
        },
        {
            key: '2',
            icon: <svg width="1em" height="1em" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.2306 20.042V36.1928" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path
                    d="M5.55225 12.8066L19.5736 19.9084C19.9473 20.0977 20.3883 20.0996 20.7636 19.9138L35.1145 12.8066"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.8304 4.87778C20.4468 4.68067 19.9914 4.68202 19.6089 4.88142L5.33352 12.3245C4.89447 12.5534 4.61914 13.0075 4.61914 13.5026L4.61914 27.9259C4.61914 28.4211 4.89447 28.8751 5.33352 29.104L19.6089 36.5471C19.9914 36.7465 20.4468 36.7479 20.8304 36.5508L35.3263 29.1023C35.7692 28.8747 36.0477 28.4185 36.0477 27.9205V13.508C36.0477 13.0101 35.7692 12.5539 35.3263 12.3263L20.8304 4.87778Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                />
            </svg>
        },
    ];

    const handleChangeTab = (k: number) => {
        setActiveTab(k);
        setActiveIcon('1');
    };

    return (
        <>
            <div className={styles.comp}>
                <div className="content">
                    <div className="side">
                        <h2 className="title">{t('title')}</h2>
                        <ul className="tabs">
                            {items?.map((item: ItemProps, k: number) => (
                                <li className={`tab ${k === activeTab ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                                    {item.tab}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="box">
                        {['1'].includes(activeIcon) && (
                            <div className="inner" id="three-container">
                                <Model3D
                                    props={{
                                        style: { width: '100%', height: '100%' },
                                        loading: 'lazy',
                                        src: activeIcon === 2 && items[activeTab]?.glb2 ? items[activeTab].glb2 : items[activeTab].glb,
                                    }}
                                />
                            </div>
                        )}
                        {activeIcon === '2' && (
                            <div className="inner">
                                <EcoImg pc={items[activeTab]?.pc} />
                            </div>
                        )}
                        <ul className="icons">
                            {icons?.map((i: any, k: number) => (
                                <li className={`icon${i.key === activeIcon ? ' active' : ''}`} key={k} onClick={() => {
                                    handleGtm(k)
                                    setActiveIcon(i.key)
                                }}>
                                    {i.icon}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
